/* eslint-disable */
/**
 * Product
 *
 * Direct copy of apps/rockwell-aem-commerce/components/commerce/product-new/clientlib/js/product.js
 * Only price and cart are removed from the source.
 */

import { ROCKWELL_BREAKPOINTS_MAX_EM } from 'js/constants.js';
import * as LS from '../../../../../partner-locator/locator-shared.js';
import { QRCode } from './qrcode.js';
import { scrollToAnchor } from 'js/ra.js';

const matchMobile = window.matchMedia(`(max-width: ${ROCKWELL_BREAKPOINTS_MAX_EM.DESKTOP}em)`);
let isPrint = false;
const componentName = 'ra-product-new';
const productDetailServletEndpoint = '/bin/rockwell-automation/product-details';
const defaultImage = '/etc.clientlibs/rockwell-aem-base/clientlibs/clientlib-base/resources/icons/image_unavailable.svg';
const productImagePrefix = 'https://configurator.rockwellautomation.com/api/Doc/';
const partnerDetailPageUrl = 'https://www.rockwellautomation.com/en-us/sales/partner-details.html';
//let userCompareData = window.localStorage.getItem('userCompareData') ? window.localStorage.getItem('userCompareData').split(' ') : [];
const closeIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                        <g clip-path="url(#clip0_1652_8264)">
                            <path d="M0.115215 9.88726C0.26346 10.0377 0.525842 10.0373 0.673213 9.8877L4.9977 5.57337L9.32611 9.88375C9.40046 9.9592 9.49929 10 9.60555 10C9.71181 10 9.81065 9.9592 9.88455 9.88419C9.92129 9.84752 9.95041 9.8039 9.97023 9.75586C9.99004 9.70782 10.0002 9.65631 10 9.60432C10.0002 9.55233 9.99004 9.50082 9.97023 9.45278C9.95041 9.40474 9.92129 9.36112 9.88455 9.32445L5.55526 5.01363L9.88455 0.675177C9.95847 0.600908 9.99998 0.500251 9.99998 0.395305C9.99998 0.290358 9.95847 0.189701 9.88455 0.115433C9.8104 0.0414983 9.7101 0 9.60555 0C9.501 0 9.4007 0.0414983 9.32655 0.115433L4.99726 4.45389L0.673213 0.115433C0.636619 0.0786576 0.593119 0.0495261 0.54523 0.0297231C0.49734 0.00992008 0.446012 -0.000161124 0.394214 6.25432e-05C0.316401 0.00065026 0.240488 0.0242357 0.175966 0.06787C0.111444 0.111504 0.0611773 0.173251 0.0314508 0.245389C0.00172421 0.317527 -0.0061428 0.396855 0.00883341 0.473454C0.0238096 0.550053 0.0609644 0.620524 0.115652 0.676054L4.43926 5.01363L0.115215 9.32796C0.0414313 9.40221 0 9.50277 0 9.60761C0 9.71245 0.0414313 9.81301 0.115215 9.88726Z" fill="white"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_1652_8264">
                                <rect width="10" height="10" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>`;
const cardRequestedFields = [
    'picture_url',
    'names_value',
    'catalogNumber',
    'productLifeCycleStatus',
    // 'names_value',
];

const resultsPerPageDefault = 15;
let resultsPerPageAccessories = resultsPerPageDefault;
let resultsPerPageAlternativeProducts = resultsPerPageDefault;

let accessoriesInitialized = false;
let alternativeProductsInitialized = false;
let knowledgebaseArticlesInitialized = false;
let drawingsInitialized = false;
let qrCodeInitialized = false;

// let pdfjsLib;

// if (typeof window !== "undefined" && window["pdfjs-dist/build/pdf"]) {
//     pdfjsLib = window["pdfjs-dist/build/pdf"];
// } else {
//     pdfjsLib = require("../build/pdf.js");
// }
class Product {

    constructor() {

        const self = this;

        const elements = {
            contentContainer: document.querySelector(`.${componentName}__content`),
            thumbnailsButton: document.querySelectorAll(".thumbnail.thumbnail__root__product"),
            menuItems: document.querySelectorAll(`.${componentName}__sidebar-item`),
            specContent: document.querySelector(`#${componentName}__spec-table`),
            specTableTabs: document.querySelectorAll(`.${componentName}__product-table-tab`),
            noData: document.querySelector(`.${componentName}__no-data`),
            drawingsIframe: document.querySelector(`.${componentName}__drawings-iframe`),
            //compareItems: document.querySelectorAll(`.${componentName}__compare-modal-item`),
        };

        if (elements.noData) {
            this.updateDistributorCard();
            this.addEventListeners();
            return;
        }

        Array.from(elements.menuItems).forEach((item) => {
            item.addEventListener('click', (event) => {
                const subChildContainer = document.getElementById(`${item.dataset.selector}-subcategory-items`);
                if(subChildContainer) {
                    subChildContainer.classList.toggle('ra-product-new__subcategory-items-collapse');
                }

                        Array.from(elements.menuItems).forEach((otherItem) => {
                        if ((item.dataset.selector === 'technical-specifications' && otherItem.dataset.selector.startsWith('technical-specifications_'))
                            || (item.dataset.selector === 'sustainability' && otherItem.dataset.selector.startsWith('sustainability_'))) {
                            const specTable = document.querySelector(`.${componentName}__content-frame-${item.dataset.selector.split('_')[0]} #${componentName}__spec-table`);
                            const specTableSectionContainers = specTable.querySelectorAll(`.${componentName}__product-table-section-container`);

                            specTableSectionContainers.forEach((container) => {
                                if (container.classList.contains('active')) {

                                    const matchingClasses = Array.from(container.classList).filter(cls =>
                                        cls.startsWith(`${componentName}__product-table-section-`)
                                    );

                                    const selectorClass = container.classList[1];


                                    if (selectorClass) {
                                        const prefix = `${componentName}__product-table-section-`;
                                        const selector = selectorClass.slice(prefix.length);

                                        if (otherItem.dataset.selector.split('_')[1] === selector) {
                                            otherItem.classList.add('active');
                                        }
                                    }
                                }
                            });
                        }
                        else if ((otherItem !== item)
                            && (item.dataset.selector.startsWith('technical-specifications_')
                                && (otherItem.dataset.selector === 'technical-specifications')
                                && (!otherItem.classList.contains('active')))
                            || (item.dataset.selector.startsWith('sustainability_')
                                && (otherItem.dataset.selector === 'sustainability')
                                && (!otherItem.classList.contains('active')))) {
                            otherItem.classList.add('active');
                        }
                        else if (otherItem !== item) {
                            const clickedGroup = item.dataset.selector.split('_')[0];
                            const otherGroup = otherItem.dataset.selector.split('_')[0];

                            // Collapse other groups visually
                            if (clickedGroup !== otherGroup) {
                                const subChildContainer = document.getElementById(`${otherItem.dataset.selector}-subcategory-items`);
                                if (subChildContainer) {
                                    subChildContainer.classList.add('ra-product-new__subcategory-items-collapse');
                                }

                                // Remove active only from parent items of other groups
                                if (!otherItem.dataset.selector.includes('_')) {
                                    otherItem.classList.remove('active');
                                }
                            }

                            // Remove active from other sub-items in the same group
                            if (
                                otherItem.dataset.selector.startsWith(clickedGroup + '_') &&
                                otherItem !== item
                            ) {
                                otherItem.classList.remove('active');
                            }
                        }
                        else if (otherItem !== item && !String(item.dataset.selector).startsWith(`${otherItem.dataset.selector}_`)) {
                            const subChildContainer = document.getElementById(`${otherItem.dataset.selector}-subcategory-items`);
                            if (subChildContainer && !subChildContainer.classList.contains('ra-product-new__subcategory-items-collapse')) {
                                subChildContainer.classList.add('ra-product-new__subcategory-items-collapse');
                            }
                        }
                    });
                item.classList.add('active');
                const selector = `${componentName}__content-frame-${item.dataset.selector}`;
                const parentSelector = `${componentName}__content-frame-${item.dataset.selector.split('_')[0]}`;
                window.location.hash = item.dataset.selector;
                if (item.dataset.selector.startsWith('technical-specifications_') || item.dataset.selector === ('technical-specifications') || item.dataset.selector.startsWith('sustainability_') || item.dataset.selector === ('sustainability')) {
                    const specKey = item.dataset.selector.split('_')[1]; // e.g., 'electrical'
                    const parts = item.dataset.selector.split('_');
                    const menuCategory = parts[0];

                    self.handleUpdateSpecTable(specKey,menuCategory);

                }
                    Array.from(elements.contentContainer.querySelectorAll(`.${componentName}__content-frame`)).forEach((frame) => {
                        if (frame.classList.contains(parentSelector)) {
                            frame.classList.add('active');
                        } else {
                            frame.classList.remove('active');
                        }
                    });
                if (item.dataset.selector === 'accessories' && !accessoriesInitialized) {
                    accessoriesInitialized = true;
                    self.initAccessories();
                } else if (item.dataset.selector === 'alternative-products' && !alternativeProductsInitialized) {
                    alternativeProductsInitialized = true;
                    self.initAlternativeProducts();
                } else if (item.dataset.selector === 'knowledgebase-articles' && !knowledgebaseArticlesInitialized) {
                    knowledgebaseArticlesInitialized = true;
                    self.initKnowledgebaseArticles();
                } else if (item.dataset.selector === 'drawings' && !drawingsInitialized) {
                    drawingsInitialized = true;
                    self.initDrawings();
                }
            });
            item.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    item.click();
                }
            });
        });
        document.querySelector('details.ra-product-new__content-frame-accessories')?.addEventListener('toggle', (event) => {
            if (event.target.open && !accessoriesInitialized) {
                accessoriesInitialized = true;
                self.initAccessories();
            }
        });
        document.querySelector('details.ra-product-new__content-frame-alternative-products')?.addEventListener('toggle', (event) => {
            if (event.target.open && !alternativeProductsInitialized) {
                alternativeProductsInitialized = true;
                self.initAlternativeProducts();
            }
        });
        document.querySelector('details.ra-product-new__content-frame-knowledgebase-articles')?.addEventListener('toggle', (event) => {
            if (event.target.open && !knowledgebaseArticlesInitialized) {
                knowledgebaseArticlesInitialized = true;
                self.initKnowledgebaseArticles();
            }
        });
        document.querySelector('details.ra-product-new__content-frame-drawings')?.addEventListener('toggle', (event) => {
            if (event.target.open && !drawingsInitialized) {
                drawingsInitialized = true;
                self.initDrawings();
            }
        });

        const initialMenuItem = document.querySelector(`.${componentName}__sidebar-item[data-selector="${window.location.hash.replace('#', '')}"]`);
        if (initialMenuItem) {
            initialMenuItem.click();
        }

        Array.from(elements.specTableTabs).forEach((tab) => {
            tab.addEventListener('click', (event) => {
                Array.from(elements.specTableTabs).forEach((otherTab) => {
                    if (otherTab !== tab) {
                        otherTab.classList.remove('active');
                    }
                });
                tab.classList.add('active');
                const selector = `${componentName}__product-table-section-${tab.dataset.selector}`;
                Array.from(elements.specContent.querySelectorAll(`.${componentName}__product-table-section-container`)).forEach((container) => {
                    if (container.classList.contains(selector)) {
                        container.classList.add('active');
                    } else {
                        container.classList.remove('active');
                    }
                });
            });
            tab.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    tab.click();
                }
            });
        });

        // Merge matching cells in first column
        const documentationTables = document.querySelectorAll(`.${componentName}__documentation-table`);
        Array.from(documentationTables).forEach((table) => {
            if (table.classList.contains(`${componentName}__documentation-table-narrow`)) {
                return;
            }
            const rows = table.querySelectorAll('tr');
            let rowSpan = 1;
            let currentType = '';
            let currentCell = null;
            Array.from(rows).forEach((row) => {
                const cell = row.querySelector('td');
                if (!cell) {
                    return;
                }
                const type = cell.getAttribute('data-type');
                if (type === currentType) {
                    rowSpan++;
                    currentCell.rowSpan = rowSpan;
                    cell.remove();
                } else {
                    currentType = type;
                    rowSpan = 1;
                    currentCell = cell;
                }
            });
        });

        this.initSignInLinks();
        this.initGalleryImageModal();
        this.initDesktopImageGallery();
        this.initSelects();
        this.initPagination();
        this.updateDistributorCard();
        this.checkProductImagesForErrors();
        //this.updatePdfTitles();

        // Check if drawings if the first tab. Init if so.
        const activeTab = document.querySelector(`.${componentName}__sidebar-item.active`);
        if (activeTab && activeTab.dataset.selector === 'drawings' && !drawingsInitialized) {
            drawingsInitialized = true;
            self.initDrawings();
        }

        this.addEventListeners();
    }

    initDesktopImageGallery() {
        const desktopImageContainer = document.querySelector(`.${componentName}__product-detail-header-content-image-desktop`);
        if (desktopImageContainer) {
        const desktopImageGallery = desktopImageContainer.querySelector(`.${componentName}__header-image-gallery`);
        if (desktopImageGallery) {
            const desktopImageGalleryArrows = desktopImageGallery.querySelectorAll(`.${componentName}__header-image-gallery-arrow`);
            if (desktopImageGallery.querySelector(`.${componentName}__header-image-gallery-container`).scrollHeight > desktopImageGallery.querySelector(`.${componentName}__header-image-gallery-container`).clientHeight) {
                [...desktopImageGalleryArrows].find((arrow) => arrow.getAttribute('data-direction') === 'next').classList.add('active');
            }
        }
    }
    }

    initGalleryImageModal() {
        const galleryModalList = document.querySelector(`.${componentName}__gallery-modal-list-container`);
        if (galleryModalList) {
            const galleryModalListArrows = document.querySelectorAll(`.${componentName}__gallery-modal-list-arrow`);
            if (galleryModalList.scrollWidth > galleryModalList.clientWidth) {
                Array.from(galleryModalListArrows).forEach((arrow) => {
                    arrow.classList.add('active');
                });
            }

            const galleryModalListResizeObserver = new ResizeObserver((entries) => {
                const galleryModalList = entries[0].target;
                const galleryModalListArrows = galleryModalList.parentElement.querySelectorAll(`.${componentName}__gallery-modal-list-arrow`);
                if (galleryModalList.scrollWidth > galleryModalList.clientWidth) {
                    Array.from(galleryModalListArrows).forEach((arrow) => {
                        arrow.classList.add('active');
                    });
                } else {
                    Array.from(galleryModalListArrows).forEach((arrow) => {
                        arrow.classList.remove('active');
                    });
                }
            });
            galleryModalListResizeObserver.observe(galleryModalList);
        }
    }

    enablePDFViewer = (pdfURL) => {
        const pdfViewerDisabled = document.getElementById('pira-pdf-viewer-disabled');
        const pdfContainer = document.querySelector('.pdf-viewer__container');

        let isExternal = true;
        try {
            if (pdfURL.includes(window.location.hostname) || pdfURL.includes('rockwellautomation.com') || pdfURL.includes('sprecherschuh.com') || pdfURL.startsWith('/content/dam/')) {
                isExternal = false;
            }
        } catch {
            // do nothing
        }

        if (pdfViewerDisabled || !pdfContainer || isExternal) {
            window.open(pdfURL, '_blank');
            return;
        }

        // replace http links with https
        pdfURL = pdfURL.replace(/^http:/, 'https:'); // eslint-disable-line no-param-reassign

        document.getElementById('cmp-pdf-viewer-container').innerHTML = `<iframe class="pdf-viewer__iframe" src="/etc.clientlibs/rockwell-aem-base/components/content/pdf-viewer/clientlibs/site/resources/viewer.html?file=${pdfURL}" ></iframe>`;
        document.body.style.overflow = 'hidden';

        // open viewer
        setTimeout(() => {
            pdfContainer.style.display = 'block';
        }, 100);

        // intercept 'local/RA' PDF links within Viewer and also open in Viewer instead of new tab
        function iFrameClick() {
            pdfContainer.querySelector('.pdf-viewer__iframe').contentWindow.document.body.onclick = (ev) => {
                ev.preventDefault();
                const originalHref = ev.target.tagName === 'A' ? ev.target.getAttribute('href') : '';
                if (originalHref && !originalHref.startsWith('#')) {
                    if (originalHref.includes('.pdf') && originalHref.includes('rockwellautomation.com')) {
                        const pdfIframe = pdfContainer.querySelector('.pdf-viewer__iframe');
                        const originalHrefHttps = originalHref.replace(/^http:/, 'https:');
                        pdfIframe.src = `/etc.clientlibs/rockwell-aem-base/components/content/pdf-viewer/clientlibs/site/resources/viewer.html?file=${originalHrefHttps}`;
                    } else {
                        window.open(originalHref, '_blank');
                    }
                }
            };
        }

        function closeLogic() {
            pdfContainer.style.display = 'none';
            document.body.style.overflow = 'auto';
            document.getElementById('cmp-pdf-viewer-container').innerHTML = '';
            pdfContainer.removeEventListener('click', closeLogic);
            window.dispatchEvent(new CustomEvent('hide-loading'));
        }

        pdfContainer.addEventListener('click', closeLogic);
        pdfContainer.querySelector('.pdf-viewer__iframe').addEventListener('load', iFrameClick);
    }

    addEventListeners() {
        // Ensure sections remain expanded on desktop
        window.addEventListener('beforeprint', (event) => {
            isPrint = true;
            const bodyZoomStyle = document.createElement('style');
            bodyZoomStyle.innerHTML = `
                @media print {
                    body {
                        zoom: 65%;
                    }

                    .footer,
                    ._hj_feedback_containers {
                        display: none;
                    }
                }
            `;
            document.head.append(bodyZoomStyle);
        });
        window.addEventListener('afterprint', (event) => {
            isPrint = false;
        });
        document.addEventListener('click', (event) => {
            if (!event.target.closest(`.${componentName}__select-container`)) {
                this.hideSelect();
            }
        });
        // const compareModal = document.querySelector(`.${componentName}__compare-modal`);
        // const compareModalTable = document.querySelector(`.${componentName}__compare-modal-frame-container`);
        // const compareButtons = document.querySelectorAll(`.${componentName}__compare-checkbox`);
        // compareButtons.forEach((compareButton) => {
        //     compareButton.addEventListener('click', async (event) => {
        //         await this.compareCheckboxClick(event);
        //     });
        //     compareButton.addEventListener('keydown', async (event) => {
        //         if (event.key === 'Enter') {
        //             await compareButton.click();
        //         }
        //     });
        // });
        // const compareModalClose = document.querySelector(`.${componentName}__compare-modal-close`);
        // compareModalClose.addEventListener('click', (event) => {
        //     const compareModal = document.querySelector(`.${componentName}__compare-modal`);
        //     compareModal.classList.remove('active');
        // });
        // compareModalClose.addEventListener('keydown', (event) => {
        //     if (event.key === 'Enter') {
        //         compareModalClose.click();
        //     }
        // });
        // const compareModalRemoveButtons = document.querySelectorAll(`.${componentName}__compare-modal-item-remove`);
        // compareModalRemoveButtons.forEach((removeButton) => {
        //     removeButton.addEventListener('click', () => {
        //         const catalogNumber = removeButton.parentElement.dataset.sku;
        //         this.removeCompareFrame(userCompareData.indexOf(catalogNumber), catalogNumber, compareModalTable);
        //         const compareButton = document.querySelector(`.${componentName}__compare-checkbox[data-sku="${catalogNumber}"]`);
        //         if (compareButton) {
        //             compareButton.checked = false;
        //         }
        //     });
        //     removeButton.addEventListener('keydown', (event) => {
        //         if (event.key === 'Enter') {
        //             removeButton.click();
        //         }
        //     });
        // });
        // const compareModalRemoveAll = document.querySelector(`.${componentName}__compare-modal-remove-all`);
        // compareModalRemoveAll.addEventListener('click', (event) => {
        //     this.removeAllCompareFrames(compareModalTable);
        //     compareButtons.forEach((button) => {
        //         button.checked = false;
        //         button.disabled = false;
        //     });
        // });

        const printButtons = document.querySelectorAll(`.${componentName}__print-button`);
        Array.from(printButtons).forEach((printButton) => {
            printButton?.addEventListener('click', (event) => {
                window.print();
            });
            printButton?.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    printButton.click();
                }
            });
        });

        const emailButtons = document.querySelectorAll(`.${componentName}__email-button`);
        Array.from(emailButtons).forEach((emailButton) => {
            emailButton?.addEventListener('click', (event) => {
                let uri = document.querySelector('link[rel="canonical"]')?.getAttribute('href');
                let catalogNumber = 'Catalog #: ' + document.querySelector(`.product-new .${componentName}__product-detail-header`)?.dataset.sku;
                let brand = 'Rockwell Automation';
                let body = document.querySelector(`.product-new .${componentName}__product-detail-header`)?.dataset.productName + ' from ' + brand + '\n' + catalogNumber + '\n' + uri + '\n';
                window.location.href = 'mailto:?subject=' + encodeURIComponent(brand + ' ' + document.querySelector(`.product-new .${componentName}__product-detail-header`)?.dataset.productName) + '&body=' + encodeURIComponent(body);
            });
            emailButton?.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    emailButton.click();
                }
            });
        });

        const qrCodeButtons = document.querySelectorAll(`.${componentName}__qr-code-button`);
        Array.from(qrCodeButtons).forEach((qrCodeButton) => {
            qrCodeButton?.addEventListener('click', (event) => {
                document.querySelector(`.${componentName}__qr-code-modal`).classList.add('active');
                if (!qrCodeInitialized) {
                    const qrCodeImg = document.querySelector(`.${componentName}__qr-code-modal-img`);
                    const qrCode = new QRCode(qrCodeImg, {
                        text: window.location.href,
                        width: 220,
                        height: 220,
                        colorDark: '#000000',
                        colorLight: '#ffffff',
                        correctLevel: QRCode.CorrectLevel.H
                    });
                    qrCodeInitialized = true;
                }
            });
            qrCodeButton?.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    qrCodeButton.click();
                }
            });
        });
        const qrModalCloseButtons = document.querySelectorAll(`.${componentName}__qr-code-modal-close, .${componentName}__qr-code-modal-close-button`);
        Array.from(qrModalCloseButtons).forEach((closeButton) => {
            closeButton.addEventListener('click', (event) => {
                document.querySelector(`.${componentName}__qr-code-modal`).classList.remove('active');
            });
            closeButton.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    closeButton.click();
                }
            });
        });

        const qrPrintButton = document.querySelector(`.${componentName}__qr-code-modal-print`);
        qrPrintButton?.addEventListener('click', () => {
            const qrModal = document.querySelector(`.${componentName}__qr-code-modal-container`);
            const qrModalStyles = document.createElement('style');
            qrModalStyles.innerHTML = `
                .${componentName}__qr-code-modal-content {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    gap: 1rem;
                    padding: 26px 40px;
                    margin: auto;
                    max-width: 100em;
                }
                .${componentName}__qr-code-modal-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 0.5rem;
                }
                .${componentName}__qr-code-modal-title {
                    color: #2D2D2D;
                    font-family: 'BarlowMedium', 'Barlow', sans-serif;
                    font-size: 24px;
                    line-height: 28px;
                }
                .${componentName}__qr-code-modal-catalog-number {
                    color: #2D2D2D;
                    font-family: 'BarlowRegular', 'Barlow', sans-serif;
                    font-size: 16px;
                    line-height: 22px;
                }
                .${componentName}__qr-code-modal-actions {
                    display: none;
                }
                .${componentName}__qr-code-modal-close {
                    display: none;
                }
                .${componentName}__qr-code-modal-close-button, .${componentName}__qr-code-modal-print {
                    display: none;
                }
            `;
            const printWindow = window.open('', '_blank');
            printWindow.document.write(qrModal.innerHTML);
            printWindow.document.head.append(qrModalStyles);
            printWindow.document.close();
            printWindow.onload = () => {
                printWindow.print();
            }
        });

        // const bomIncrementButtons = document.querySelectorAll(`.${componentName}__bom-numberfield-increment`);
        // const bomNumberfield = document.querySelector(`.${componentName}__bom-numberfield-input-value`);
        // bomIncrementButtons.forEach((button) => {
        //     button.addEventListener('click', () => {
        //         if (button.classList.contains('disabled')) {
        //             return;
        //         }
        //         if (button.classList.contains(`${componentName}__bom-numberfield-increment-minus`)) {
        //             this.incrementNumberfield(bomNumberfield, -1);
        //             if (parseInt(bomNumberfield.value) <= parseInt(bomNumberfield.min)) {
        //                 button.classList.add('disabled');
        //             } else {
        //                 button.classList.remove('disabled');
        //             }
        //             document.querySelector(`.${componentName}__bom-numberfield-increment-plus`).classList.remove('disabled');
        //         } else if (button.classList.contains(`${componentName}__bom-numberfield-increment-plus`)) {
        //             this.incrementNumberfield(bomNumberfield, 1);
        //             if (parseInt(bomNumberfield.value) >= parseInt(bomNumberfield.max)) {
        //                 button.classList.add('disabled');
        //             } else {
        //                 button.classList.remove('disabled');
        //             }
        //             document.querySelector(`.${componentName}__bom-numberfield-increment-minus`).classList.remove('disabled');
        //         }
        //     });
        //     button.addEventListener('keydown', (event) => {
        //         if (event.key === 'Enter') {
        //             button.click();
        //         }
        //     });
        // });
        // bomNumberfield.addEventListener('input', () => {
        //     if (parseInt(bomNumberfield.value) > parseInt(bomNumberfield.min)) {
        //         document.querySelector(`.${componentName}__bom-numberfield-increment-minus`).classList.remove('disabled');
        //     } else {
        //         document.querySelector(`.${componentName}__bom-numberfield-increment-minus`).classList.add('disabled');
        //     }
        //     if (parseInt(bomNumberfield.value) < parseInt(bomNumberfield.max)) {
        //         document.querySelector(`.${componentName}__bom-numberfield-increment-plus`).classList.remove('disabled');
        //     } else {
        //         document.querySelector(`.${componentName}__bom-numberfield-increment-plus`).classList.add('disabled');
        //     }
        // });

        const imageThumbnails = document.querySelectorAll(`.${componentName}__header-image-gallery-frame`);
        const galleryModal = document.querySelector(`.${componentName}__gallery-modal`);
        const desktopMainImages = document.querySelectorAll(`.ra-product-new__product-detail-header-content .multimedia-grid .main-image`);
        Array.from(desktopMainImages).forEach((image) => {
            image.addEventListener('click', (event) => {
                if (image.classList.contains(`${componentName}__default-image`)) {
                    return;
                }
                galleryModal.classList.add('active');
            });
            image.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    image.click();
                }
            });
        });
        const galleryModalListFrames = galleryModal.querySelectorAll(`.${componentName}__gallery-modal-list-frame`);
        const mobileMainImages = document.querySelectorAll(`.${componentName}__main-image`);

        Array.from(imageThumbnails).forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', (event) => {
                const image = thumbnail.querySelector('img');
                Array.from(mobileMainImages).forEach((mainImage) => {
                    mainImage.src = image.src;
                });
                [...galleryModalListFrames].find((frame) => frame.querySelector('img').src === image.src)?.click();
            });

            thumbnail.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    thumbnail.click();
                }
            });
        });
        const galleryModalBackground = galleryModal.querySelector(`.${componentName}__gallery-modal-background`);
        galleryModalBackground?.addEventListener('click', (event) => {
            galleryModal.classList.remove('active');
        });
        const galleryModalImage = galleryModal.querySelector(`.${componentName}__gallery-modal-image`);
        const galleryModalMainArrows = galleryModal.querySelectorAll(`.${componentName}__gallery-modal-main-arrow`);
        Array.from(galleryModalMainArrows).forEach((arrow) => {
            arrow.addEventListener('click' , (event) => {
                const currentImage = galleryModal.querySelector(`.${componentName}__gallery-modal-list-frame.active`);
                const arrowDirection = arrow.getAttribute('data-direction');
                let nextImage;
                if (arrowDirection === 'next') {
                    nextImage = currentImage.nextElementSibling ? currentImage.nextElementSibling : currentImage.parentElement.firstElementChild;
                } else if (arrowDirection === 'prev') {
                    nextImage = currentImage.previousElementSibling ? currentImage.previousElementSibling : currentImage.parentElement.lastElementChild;
                }
                currentImage.classList.remove('active');
                nextImage.classList.add('active');
                galleryModalImage.src = nextImage.querySelector('img').src;
            });
            arrow.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    arrow.click();
                }
            });
        });
        Array.from(galleryModalListFrames).forEach((frame) => {
            frame.addEventListener('click', (event) => {
                if (frame.classList.contains('active')) {
                    return;
                }
                const currentImage = galleryModal.querySelector(`.${componentName}__gallery-modal-list-frame.active`);
                currentImage.classList.remove('active');
                frame.classList.add('active');
                galleryModalImage.src = frame.querySelector('img').src;
            });
            frame.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    frame.click();
                }
            });
        });
        if (galleryModalImage) {
            galleryModalImage.addEventListener('click', (event) => {
                if (galleryModalImage.classList.contains(`${componentName}__gallery-modal-image--zoomed-out`)) {
                    galleryModalImage.style.setProperty('--horizontal-origin', `${(event.offsetX / galleryModalImage.clientWidth) * 100}%`);
                    galleryModalImage.style.setProperty('--vertical-origin', `${(event.offsetY / galleryModalImage.clientHeight) * 100}%`);
                    galleryModalImage.classList.remove(`${componentName}__gallery-modal-image--zoomed-out`);
                    galleryModalImage.classList.add(`${componentName}__gallery-modal-image--zoomed-in`);
                } else {
                    galleryModalImage.classList.remove(`${componentName}__gallery-modal-image--zoomed-in`);
                    galleryModalImage.classList.add(`${componentName}__gallery-modal-image--zoomed-out`);
                }
            });
            let mouseEventDebounce = false;
            const mouseEventDebounceTimer = 5;
            galleryModalImage.addEventListener('mousemove', (event) => {
                if (mouseEventDebounce) {
                    return;
                }
                galleryModalImage.style.setProperty('--horizontal-origin', `${(event.offsetX / galleryModalImage.clientWidth) * 100}%`);
                galleryModalImage.style.setProperty('--vertical-origin', `${(event.offsetY / galleryModalImage.clientHeight) * 100}%`);
                mouseEventDebounce = true;
                setTimeout(() => {
                    mouseEventDebounce = false;
                }, mouseEventDebounceTimer);
            });
        }
        const galleryModalListArrows = galleryModal.querySelectorAll(`.${componentName}__gallery-modal-list-arrow`);
        const galleryModalList = galleryModal.querySelector(`.${componentName}__gallery-modal-list-container`);
        Array.from(galleryModalListArrows).forEach((arrow) => {
            arrow.addEventListener('click', () => {
                const arrowDirection = arrow.getAttribute('data-direction');
                this.sideScroll(galleryModalList, arrowDirection, 10, 200, 10);
            });
            arrow.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    arrow.click();
                }
            });
        });

        const galleryHeaderListArrows = document.querySelectorAll(`.${componentName}__header-image-gallery-arrow`);
        const galleryHeaderList = document.querySelector(`.${componentName}__header-image-gallery-container`);
        Array.from(galleryHeaderListArrows).forEach((arrow) => {
            arrow.addEventListener('click', () => {
                const arrowDirection = arrow.getAttribute('data-direction');
                this.verticalScroll(galleryHeaderList, arrowDirection, 10, 200, 10);

                // If the gallery is scrolled to the top or bottom, hide the arrow
                setTimeout(() => {
                    if (galleryHeaderList.scrollTop === 0) {
                        [...galleryHeaderListArrows].find((arrowInner) => arrowInner.getAttribute('data-direction') === 'prev').classList.remove('active');
                    } else {
                        [...galleryHeaderListArrows].find((arrowInner) => arrowInner.getAttribute('data-direction') === 'prev').classList.add('active');
                    }
                    if (galleryHeaderList.scrollTop === galleryHeaderList.scrollHeight - galleryHeaderList.clientHeight) {
                        [...galleryHeaderListArrows].find((arrowInner) => arrowInner.getAttribute('data-direction') === 'next').classList.remove('active');
                    } else {
                        [...galleryHeaderListArrows].find((arrowInner) => arrowInner.getAttribute('data-direction') === 'next').classList.add('active');
                    }
                }, 250);
            });
            arrow.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    arrow.click();
                }
            });
        });

        const pageLanguage = document.querySelector('meta[property="language"]') ? document.querySelector('meta[property="language"]').content.substr(0, 2) : 'en';
        const pageCountry = document.querySelector('meta[property="country"]') ? document.querySelector('meta[property="country"]').content : 'US';
        document.querySelectorAll('a').forEach((link) => {
            const originalHref = link.getAttribute('href');
            if (/\.pdf(\?.+)?$/.test(originalHref)) {
                link.addEventListener('click', async (ev) => {
                    // Links on non-EN pages, pointing to Lit Lib, that are not within AB documentation resource tables
                    ev.preventDefault();
                    ev.stopPropagation();
                    const pdfLanguage = pageCountry === 'TW' ? 'zc' : pageLanguage;
                    if (pdfLanguage !== 'en' && originalHref.match(/.+literature\.rockwellautomation\.com.+/) && !(link.parentNode.getAttribute('data-label') === 'Language')) {
                        const translatedPdf = originalHref.replace(/^https?(.+-)([a-z]{2})(_[A-Z]{2})?(-.*?\.pdf.*)$/, `https$1${pdfLanguage}$4`);
                        const englishPdf = originalHref.replace(/^https?(.+-)([a-z]{2})(_[A-Z]{2})?(-.*?\.pdf.*)$/, 'https$1en$4');
                        try {
                            const response = await fetch(translatedPdf, { method: 'HEAD' });
                            if (!response.ok) {
                                throw new Error();
                            }
                            console.log('Translated PDF exists, opening it');
                            this.enablePDFViewer(translatedPdf); // If translated PDF exists, open it
                        } catch {
                            console.log('Translated PDF does not exist, opening English PDF');
                            this.enablePDFViewer(englishPdf); // Otherwise open English PDF
                        }
                    } else {
                        console.log('PDF link is not translated, opening it');
                        this.enablePDFViewer(originalHref);
                    }
                    // Click anywhere on the page to close the PDF viewer.
                });
            }
        });

        // Add serial number tooltip functionality
        this.initSerialNumberTooltip();
    }

    sideScroll = (element, direction, speed, distance, step) => {
        let scrollAmount = 0;
        const slideTimer = setInterval(() => {
            if (direction == 'prev') {
                element.scrollLeft -= step;
            } else if (direction == 'next') {
                element.scrollLeft += step;
            }
            scrollAmount += step;
            if (scrollAmount >= distance) {
                window.clearInterval(slideTimer);
            }
        }, speed);
    }

    verticalScroll = (element, direction, speed, distance, step) => {
        let scrollAmount = 0;
        const slideTimer = setInterval(() => {
            if (direction == 'prev') {
                element.scrollTop -= step;
            } else if (direction == 'next') {
                element.scrollTop += step;
            }
            scrollAmount += step;
            if (scrollAmount >= distance) {
                window.clearInterval(slideTimer);
            }
        }, speed);
    }

    initSignInLinks = () => {
        if (localStorage.getItem('adfsLogin')) {
            const signInLinks = document.querySelectorAll(`.${componentName}__sign-in-link`);
            Array.from(signInLinks).forEach((link) => {
                link.href = localStorage.getItem('adfsLogin');
            });
        }
    }

    async checkProductImagesForErrors() {
        const productImages = document.querySelectorAll(`.${componentName}__product-image`);
        Array.from(productImages).forEach((image) => {
            // Use the data-default-image attribute if available, otherwise fall back to the hardcoded defaultImage
            const imageDefaultSrc = image.dataset.defaultImage || defaultImage;
            
            image.onerror = () => {
                image.src = imageDefaultSrc;
                image.classList.add(`${componentName}__default-image`);
            };
            // Check if error has already fired
            if (image.complete && !image.naturalWidth) {
                image.src = imageDefaultSrc;
                image.classList.add(`${componentName}__default-image`);
            }
        });
    }
    // async compareCheckboxClick(event) {
    //     const compareButtons = document.querySelectorAll(`.${componentName}__compare-checkbox`);
    //     const compareButton = event.target;
    //     const catalogNumber = compareButton.dataset.sku;
    //     console.log('catalogNumber', catalogNumber);
    //     if (compareButton.checked) {
    //         if (!userCompareData.includes(catalogNumber) && userCompareData.length < 4) {
    //             userCompareData.push(catalogNumber);
    //             window.localStorage.setItem('userCompareData', userCompareData.join(' '));
    //             if (userCompareData.length === 4) {
    //                 compareButtons.forEach((button) => {
    //                     if (!userCompareData.includes(button.dataset.sku)) {
    //                         button.disabled = true;
    //                     }
    //                 });
    //             }
    //         }
    //     } else {
    //         const removeButton = document.querySelector(`.${componentName}__compare-modal-item[data-sku="${catalogNumber}"] .${componentName}__compare-modal-item-remove`);
    //         if (removeButton) {
    //             removeButton.click();
    //         }
    //     }
    //     await this.showCompareModal();
    // }

    incrementNumberfield(input, step) {
        if ((parseInt(input.value) + step) < parseInt(input.min) || (parseInt(input.value) + step) > parseInt(input.max)) {
            return;
        }
        input.value = parseInt(input.value) + step;
    }

    // async showCompareModal() {
    //     const compareModal = document.querySelector(`.${componentName}__compare-modal`);
    //     const compareModalTable = document.querySelector(`.${componentName}__compare-modal-frame-container`);
    //     const compareModalCount = document.querySelector(`.${componentName}__compare-modal-count-number`);
    //     const compareModalItems = document.querySelectorAll(`.${componentName}__compare-modal-item`);
    //     compareModalCount.innerText = userCompareData.length;
    //     const compareValues = [];
    //     compareModalTable.querySelectorAll('tr').forEach((row) => {
    //         if (row.classList.contains(`${componentName}__compare-modal-frame-content-specification`)) {
    //             row.remove();
    //         } else {
    //             row.querySelectorAll('td').forEach((cell, index) => {
    //                 cell.remove();
    //             });
    //         }
    //     });
    //     compareValues.forEach((compareValue, index) => {
    //         const compareValueRow = document.createElement('tr');
    //         compareValueRow.classList.add(`${componentName}__compare-modal-frame-content-specification`);
    //         compareValueRow.classList.add(`${componentName}__compare-modal-frame-content-specification-${index}`);
    //         const specTitle = compareValue.split('||')[1].trim();
    //         const newCompareValueTitle = document.createElement('th');
    //         newCompareValueTitle.innerText = specTitle;
    //         compareValueRow.append(newCompareValueTitle);
    //         compareModalTable.append(compareValueRow);
    //     });
    //     if (userCompareData.length > 0) {
    //         const jsonData = await this.getCompareData(userCompareData);
    //         // Check if jsonData is array or object
    //         if (jsonData.length) {
    //             jsonData.forEach((element, index) => {
    //                 this.createCompareFrame(element, index, compareValues, compareModalTable);
    //             });
    //         } else {
    //             this.createCompareFrame(jsonData, 0, compareValues, compareModalTable);
    //         }
    //     }
    //     compareModal.classList.add('active');
    // }

    // removeCompareFrame(index, catalogNumber, compareModalTable) {
    //     userCompareData.splice(index, 1);
    //     window.localStorage.setItem('userCompareData', userCompareData.join(' '));
    //     const compareModalCount = document.querySelector(`.${componentName}__compare-modal-count-number`);
    //     compareModalCount.innerText = userCompareData.length;
    //     compareModalTable.querySelectorAll('tr').forEach((row) => {
    //         row.querySelectorAll('td').forEach((cell, cellIndex) => {
    //             if ((cellIndex - 1) === index) {
    //                 cell.remove();
    //             }
    //         });
    //     });
    //     this.updateCompareThumbnail(index, catalogNumber);
    // }

    // removeAllCompareFrames(compareModalTable) {
    //     userCompareData = [];
    //     window.localStorage.setItem('userCompareData', userCompareData.join(' '));
    //     for (let i = 0; i < 4; i++) {
    //         this.updateCompareThumbnail(i, '');
    //     }
    //     const compareModalCount = document.querySelector(`.${componentName}__compare-modal-count-number`);
    //     compareModalCount.innerText = userCompareData.length;
    //     compareModalTable.querySelectorAll('tr').forEach((row) => {
    //         row.querySelectorAll('td').forEach((cell) => {
    //             cell.remove();
    //         });
    //     });
    // }

    // createCompareFrame(jsonData, index, compareValues, compareModalTable) {
    //     const catalogNumber = (jsonData.catalogNumber && jsonData.catalogNumber != 'null') ? jsonData.catalogNumber : 'N/A';
    //     const productName = (jsonData.names_value && jsonData.names_value != 'null') ? jsonData.names_value.replaceAll(',', ', ') : 'N/A';
    //     const productImage = (jsonData.picture_url && jsonData.picture_url != 'null') ? jsonData.picture_url : defaultImage;
    //     this.updateCompareThumbnail(index, catalogNumber, productImage);
    //     compareModalTable.querySelectorAll('tr').forEach((row) => {
    //         row.append(document.createElement('td'));
    //     });
    //     compareModalTable.querySelector(`.${componentName}__compare-modal-frame-catalog-number td:last-child`).innerText = catalogNumber;
    //     compareModalTable.querySelector(`.${componentName}__compare-modal-frame-image td:last-child`).append(document.createElement('img'));
    //     compareModalTable.querySelector(`.${componentName}__compare-modal-frame-image td:last-child`).append(document.createElement('span'));
    //     compareModalTable.querySelector(`.${componentName}__compare-modal-frame-image td:last-child span`).innerHTML = closeIcon;
    //     compareModalTable.querySelector(`.${componentName}__compare-modal-frame-image td:last-child span`).addEventListener('click', (event) => {
    //         this.removeCompareFrame(userCompareData.indexOf(catalogNumber), catalogNumber, compareModalTable);
    //     });
    //     compareModalTable.querySelector(`.${componentName}__compare-modal-frame-image td:last-child img`).src = productImage;
    //     compareValues.forEach((compareValue, index) => {
    //         const specGroup = compareValue.split('||')[0].trim();
    //         const specTitle = compareValue.split('||')[1].trim();
    //         let specValue;
    //         if (specGroup == 'Sales Info') {
    //             specValue = jsonData[`salesOrg__${this.toCamelCase(specTitle)}`] ? jsonData[`salesOrg__${this.toCamelCase(specTitle)}`] : jsonData[this.toCamelCase(specTitle)];
    //         } else {
    //             specValue = jsonData.classificationFeaturesArray.find((element) => {
    //                 if ((specGroup == element.group_name || specGroup == 'General') && specTitle == element.classification_name) {
    //                     return element;
    //                 }
    //             })?.value;
    //         }
    //         if (specValue == undefined) {
    //             specValue = 'N/A';
    //         }
    //         compareModalTable.querySelector(`.${componentName}__compare-modal-frame-content-specification-${index} td:last-child`).innerText = specValue;
    //     });
    // }

    // async getCompareData(catalogNumbers) {
    //     if (!catalogNumbers.length) {
    //         return [];
    //     }
    //     const url = new URL(`${window.location.origin}${productDetailServletEndpoint}?catalogNumber=${catalogNumbers.join(',')}&app=RA`);
    //     const response = await fetch(url);
    //     const jsonData = await response.json();
    //     return jsonData;
    // }

    // updateCompareThumbnail(index, catalogNumber, image) {
    //     const compareModalItems = document.querySelectorAll(`.${componentName}__compare-modal-item`);
    //     if (image) {
    //         compareModalItems[index].dataset.sku = catalogNumber;
    //         compareModalItems[index].querySelector(`.${componentName}__compare-modal-item-image img`).src = image;
    //         compareModalItems[index].querySelector(`.${componentName}__compare-modal-item-image img`).alt = catalogNumber;
    //         compareModalItems[index].querySelector(`.${componentName}__compare-modal-item-image`).classList.add('active');
    //         compareModalItems[index].querySelector(`.${componentName}__compare-modal-item-remove`).classList.add('active');
    //     } else {
    //         compareModalItems[index].dataset.sku = '';
    //         compareModalItems[index].querySelector(`.${componentName}__compare-modal-item-image img`).src = '';
    //         compareModalItems[index].querySelector(`.${componentName}__compare-modal-item-image img`).alt = '';
    //         compareModalItems[index].querySelector(`.${componentName}__compare-modal-item-image`).classList.remove('active');
    //         compareModalItems[index].querySelector(`.${componentName}__compare-modal-item-remove`).classList.remove('active');
    //         for (index; index < 3; index++) {
    //             if (userCompareData[index]) {
    //                 this.updateCompareThumbnail(index, userCompareData[index], compareModalItems[(index + 1)].querySelector(`.${componentName}__compare-modal-item-image img`).src);
    //                 this.updateCompareThumbnail((index + 1), userCompareData[index]);
    //             }
    //         }
    //     }
    // }

    handleUpdateSpecTable(selector,menu) {
        if (!selector) return;
        const scope = menu
                ? document.querySelector(`.ra-product-new__content-frame-${menu}`)
                : document;
        const specTableSectionContainers = scope.querySelectorAll(`.${componentName}__product-table-section-container`);
            specTableSectionContainers.forEach(container => container.classList.remove('active'));
            if (selector) {
                const targetContainer = scope.querySelector(`.${componentName}__product-table-section-${selector}`);
                if (targetContainer) {
                    targetContainer.classList.add('active');
                }
            }
    }

     handleSelectUpdateSpecTable(selector, menu) {
        const specTableSectionContainers = document.querySelectorAll(`.${componentName}__product-table-section-container`);
        Array.from(specTableSectionContainers).forEach((container) => {   
            if (container.getAttribute('data-category') === menu) {
                container.classList.remove('active');
            }
            if (container.classList.contains(`${componentName}__product-table-section-${selector}`)) {
                container.classList.add('active');
            }
        });
    }


    toCamelCase(str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, '');
    }
    toTitleCase(str) {
        return str.replace(/\w\S*/g, (txt) => {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }

    initSelects() {
        Array.from(document.querySelectorAll(`.${componentName}__select-input`)).forEach((select) => {
            if ((select.getAttribute('name') === 'specTableSelectDesktop' || select.getAttribute('name') === 'specTableSelectMobile') && select.querySelectorAll('option').length <= 1) {
                select.remove();
                return;
            }
            const fakeSelect = document.createElement('div');
            fakeSelect.classList.add(`${componentName}__select`);
            fakeSelect.setAttribute('name', select.getAttribute('name'));
            fakeSelect.setAttribute('data-category', select.getAttribute('data-category'));


            const fakeSelectLabel = document.createElement('div');
            fakeSelectLabel.classList.add(`${componentName}__select-label`);
            fakeSelectLabel.setAttribute('data-category', select.getAttribute('data-category'));
            fakeSelectLabel.innerText = select.querySelector('option[selected=\'selected\']') ? select.querySelector('option[selected=\'selected\']').label : select.querySelector('option').label;
            let fakeSelectLabelWidth = 0;

            const optionList = document.createElement('ul');
            fakeSelect.appendChild(optionList);
            fakeSelectLabel.addEventListener('click', function() {
                const category = this.getAttribute('data-category');
                document.querySelectorAll('.ra-product-new__select').forEach(dropdown => {
                    if (dropdown.getAttribute('data-category') === category) {
                        dropdown.classList.toggle('active');
                    } else {
                        dropdown.classList.remove('active');
                    }
                });
            });

            [...select.querySelectorAll('option')].forEach((option, index) => {
                const fakeOption = document.createElement('li');
                fakeOption.setAttribute('value', option.value);
                if (index === 0) {
                    fakeOption.classList.add('selected');
                }
                fakeOption.innerText = option.label;
                fakeOption.addEventListener('click', () => this.handleSelect(fakeOption));
                optionList.appendChild(fakeOption);
                const fakeOptionClone = fakeOption.cloneNode(true);
                fakeOptionClone.style.position = 'absolute';
                fakeOptionClone.style.visibility = 'hidden';
                fakeOptionClone.style.whiteSpace = 'nowrap';
                fakeOptionClone.style.width = 'fit-content';
                document.body.appendChild(fakeOptionClone);
                if (fakeOptionClone.clientWidth > fakeSelectLabelWidth) {
                    fakeSelectLabelWidth = fakeOptionClone.clientWidth;
                    fakeSelectLabel.style.setProperty('--select-width', `${fakeSelectLabelWidth + 25}px`);
                }
                fakeOptionClone.remove();
            });

            select.insertAdjacentElement('afterEnd', fakeSelectLabel);
            select.insertAdjacentElement('afterEnd', fakeSelect);

            const initValue = select.getAttribute('data-init-value');
            if (initValue !== null) {
                select.value = initValue;
                if (select.querySelector(`option[value='${initValue}']`) !== null) {
                    select.querySelector(`option[value='${initValue}']`).selected = 'selected';
                    fakeSelectLabel.innerText = select.querySelector(`option[value='${initValue}']`).label;
                }
            }
        });
    }

    toggleSelect(selectName) {
        const fakeSelect = document.querySelector(`.${componentName}__select[name='${selectName}']`);
        if (fakeSelect.classList.contains('active')) {
            fakeSelect.classList.remove('active');
            return;
        }
        this.hideSelect();
        fakeSelect.classList.add('active');
    }

    hideSelect() {
        [...document.querySelectorAll(`.${componentName}__select`)].forEach((select) => {
            select.classList.remove('active');
        });
    }

    handleSelect(fakeOption) {
        [...fakeOption.closest('ul').querySelectorAll('li')].forEach((li) => {
            li.classList.remove('selected');
        });
        fakeOption.classList.add('selected');
        const fakeSelectLabel = fakeOption.closest(`.${componentName}__select-container`).querySelector(`.${componentName}__select-label`);
        fakeSelectLabel.innerText = fakeOption.innerText;

        const realOption = document.querySelector(`option[value='${fakeOption.getAttribute('value')}']`);
        realOption.selected = 'selected';
        realOption.closest('select').value = fakeOption.getAttribute('value');

        const selectElement = realOption.closest('select');
        const menuCategory = selectElement ? selectElement.getAttribute('data-category') : null;
       if (realOption.closest('select').classList.contains(`${componentName}__product-table-select`)) {
            this.handleSelectUpdateSpecTable(fakeOption.getAttribute('value'), menuCategory);
        }

        // Close the dropdown after selection
        this.hideSelect();
    }

    async updatePdfTitles() {
        const pdfLinks = [...document.querySelectorAll('a')].filter((link) => link.href.endsWith('.pdf'));
        pdfLinks.forEach(async (link) => {
            const url = link.href;
            const response = await fetch(url);
            const responseText = await response.text();
            const metadataTitle = responseText.split('<dc:title>')[1].split('</dc:title>')[0];
            const titleXmlElement = new DOMParser().parseFromString(metadataTitle, 'text/xml');

            const title = titleXmlElement.querySelector('rdf\\:li').textContent;
            link.innerHTML = title;
        });
    }

    sortDistributors = (docs, aprCode, userLocation) => {
        const sortedDocs = docs.sort((a, b) => {
            const opCoIdxA = LS.getNearestOpCoIndex(a, aprCode, userLocation);
            const opCoIdxB = LS.getNearestOpCoIndex(b, aprCode, userLocation);
            const aCode = +LS.getField(a, LS.Fields.Distributor.LevelCode, opCoIdxA);
            const bCode = +LS.getField(b, LS.Fields.Distributor.LevelCode, opCoIdxB);
            return aCode - bCode;
        });
        return sortedDocs;
    }

    async updateDistributorCard() {
        const distributorCardPartner = document.querySelector(`.${componentName}__distributor-card-partner`);
        if (!distributorCardPartner) {
            return;
        }
        const distributorCardLoader = document.querySelector(`.${componentName}__distributor-card .loader`);
        const distributorCardContent = document.querySelector(`.${componentName}__distributor-card-content`);
        try {
            // Wait for window.getPiraObj() to be available
            if (typeof window.getPiraObj === 'function') {
                await this.fillDistributorCard();
            } else {
                document.addEventListener('piraLoadedSynced', async () => {
                    await this.fillDistributorCard();
                });
            }
        } catch (error) {
            console.warn('Error fetching distributor data', error);
            distributorCardPartner.remove();
            distributorCardContent.classList.remove('hidden');
            distributorCardLoader.remove();
        }
    }

    async fillDistributorCard() {
        const distributorCardPartner = document.querySelector(`.${componentName}__distributor-card-partner`);
        const distributorCardLoader = document.querySelector(`.${componentName}__distributor-card .loader`);
        const distributorCardContent = document.querySelector(`.${componentName}__distributor-card-content`);

        let userLocation = window.localStorage.getItem('ra_locator_search_location') ? JSON.parse(window.localStorage.getItem('ra_locator_search_location')) : {};
        if (!userLocation.name || !userLocation.latitude || !userLocation.longitude) {
            userLocation = await LS.readUserLocation(true);
        }
        if (!userLocation.latitude || !userLocation.longitude) {
            distributorCardLoader.remove();
            distributorCardContent.classList.remove('hidden');
            return;
        }
        if (window.localStorage.getItem('ra_locator_search_location') && userLocation.name) {
            document.querySelector(`.${componentName}__distributor-card-text-custom`).innerText = document.querySelector(`.${componentName}__distributor-card-text-custom`).innerText.replace('{0}', `${userLocation.name.includes(',') ? userLocation.name.split(',')[0] : userLocation.name}`);
            document.querySelector(`.${componentName}__distributor-card-text-custom`).classList.remove('hidden');
            document.querySelector(`.${componentName}__distributor-card-text`).classList.add('hidden');
        }
        const resultsToDisplay = 4;
        const distributorDataParams = {
            facets: 'rl_partner_type_s:("Authorized Distributor")',
            geoPoint: `${userLocation.latitude},${userLocation.longitude}`,
            startIndex: 0,
            numResults: resultsToDisplay,
        }
        const distributorData = await LS.fetchData(distributorDataParams);
        const fqField = [distributorData.responseHeader?.params?.fq].flat(); // fq field can be either a string or an array, always grab it as an array
        const aprCodeField = fqField.find((str) => String(str).startsWith('rl_apr_code'));
        const aprCode = aprCodeField // extract 'TH1' from 'rl_apr_code_ss:("n/a" or "TH1")'
            ?.match(/\((.*)\)/)?.[1] // returns '"n/a" or "TH1"'
            .split('or') // returns ['"n/a" ', ' "TH1"']
            .map((value) => value.match(/"(.*)"/)?.[1]) // returns ["n/a", "TH1"]
            .filter((value) => value != null && value !== 'n/a')?.[0]; // returns "TH1"
        const state = {
            aprCode,
            docs: distributorData?.response?.docs,
        };
        const sortedDocs = this.sortDistributors(state.docs, aprCode, userLocation);
        for (let i = 0; i < resultsToDisplay; i++) {
            if (!sortedDocs[i]) {
                continue;
            }
            const opCoIdx = LS.getNearestOpCoIndex(sortedDocs[i], aprCode, userLocation);
            const cardInfo = {
                partnerId: LS.getField(sortedDocs[i], LS.Fields.Id),
                partnerType: LS.getField(sortedDocs[i], LS.Fields.PartnerType),
                partnerName: LS.getField(sortedDocs[i], LS.Fields.Distributor.Name, opCoIdx),
                partnerEmail: LS.getField(sortedDocs[i], LS.Fields.Distributor.Email, opCoIdx),
                partnerPhone: LS.getField(sortedDocs[i], LS.Fields.Distributor.LocationPhone, opCoIdx),
                city: LS.getField(sortedDocs[i], LS.Fields.Locations.City, opCoIdx),
            };
            const partnerData = await LS.fetchData({
                facets: `id:${cardInfo.partnerId}`,
                startIndex: 0,
                numResults: 1,
            });
            const partnerImageSrc = await LS.getOpCoLogo({
                apiData: sortedDocs[i],
                aprCode,
                parentLocationId: LS.getField(partnerData?.response?.docs?.[0], LS.Fields.PrimaryLocation.Id),
                parentPartnerId: LS.getField(sortedDocs[i], LS.Fields.Id)
            });
            if (cardInfo.partnerName && cardInfo.partnerId) {
                const partnerDetailElement = distributorCardPartner.cloneNode(true);
                partnerDetailElement.classList.remove('hidden');

                partnerDetailElement.querySelector(`.${componentName}__distributor-card-partner-link`).href = `${partnerDetailPageUrl}?id=${cardInfo.partnerId}&ac=${aprCode}`;

                if (partnerImageSrc) {
                    partnerDetailElement.querySelector(`.${componentName}__distributor-card-icon-img`).src = partnerImageSrc;
                    partnerDetailElement.querySelector(`.${componentName}__distributor-card-icon-img`).alt = cardInfo.partnerName;
                    partnerDetailElement.querySelector(`.${componentName}__distributor-card-icon-img`).addEventListener('error', () => {
                        partnerDetailElement.querySelector(`.${componentName}__distributor-card-icon`).remove();
                        partnerDetailElement.querySelector(`.${componentName}__distributor-card-partner-link`).innerText = cardInfo.partnerName;
                    });
                } else {
                    partnerDetailElement.querySelector(`.${componentName}__distributor-card-icon`).remove();
                    partnerDetailElement.querySelector(`.${componentName}__distributor-card-partner-link`).innerText = cardInfo.partnerName;
                }
                if (cardInfo.partnerEmail) {
                    partnerDetailElement.querySelector(`.${componentName}__distributor-card-actions-email`).setAttribute('data-email', cardInfo.partnerEmail);
                    partnerDetailElement.querySelector(`.${componentName}__distributor-card-actions-email`).setAttribute('data-name', cardInfo.partnerName);
                    partnerDetailElement.querySelector(`.${componentName}__distributor-card-actions-email`).addEventListener('click', LS.openGatedForm);
                } else {
                    partnerDetailElement.querySelector(`.${componentName}__distributor-card-actions-email`).classList.add('disabled');
                }
                if (cardInfo.partnerPhone) {
                    partnerDetailElement.querySelector(`.${componentName}__distributor-card-actions-phone`).setAttribute('data-phone', cardInfo.partnerPhone);
                    partnerDetailElement.querySelector(`.${componentName}__distributor-card-actions-phone`).setAttribute('data-title', cardInfo.partnerName);
                    partnerDetailElement.querySelector(`.${componentName}__distributor-card-actions-phone`).addEventListener('click', () => {
                        this.openContactDialog(cardInfo, partnerDetailElement.querySelector(`.${componentName}__distributor-card-actions-phone`));
                    });
                } else {
                    partnerDetailElement.querySelector(`.${componentName}__distributor-card-actions-phone`).classList.add('disabled');
                }
                if (cardInfo.city && !(window.localStorage.getItem('ra_locator_search_location') && userLocation.name)) {
                    document.querySelector(`.${componentName}__distributor-card-text-custom`).innerText = document.querySelector(`.${componentName}__distributor-card-text-custom`).innerText.replace('{0}', `${cardInfo.city}`);
                    document.querySelector(`.${componentName}__distributor-card-text-custom`).classList.remove('hidden');
                    document.querySelector(`.${componentName}__distributor-card-text`).classList.add('hidden');
                }
                distributorCardPartner.insertAdjacentElement('beforebegin', partnerDetailElement);
                const divider = document.createElement('div');
                divider.classList.add(`${componentName}__divider`);
                distributorCardPartner.insertAdjacentElement('beforebegin', divider);
            }
        }
        distributorCardPartner.remove();
        distributorCardContent.classList.remove('hidden');
        distributorCardLoader.remove();
    }

    openContactDialog(cardInfo, targetEl) {
        const contactDialog = document.querySelector(`#${componentName}__office-contact-dialog`);
        contactDialog.querySelector('.contact-dialog__title').innerText = cardInfo.partnerName;
        contactDialog.querySelector('.contact-dialog__number').innerText = cardInfo.partnerPhone;
        contactDialog.querySelector('.contact-dialog__call-button').href = `tel:${cardInfo.partnerPhone}`;
        contactDialog.show();
        targetEl.dispatchEvent(new CustomEvent('locator__phone-clicked', { detail: targetEl.dataset, bubbles: true }));
    }

    showGridSkeleton(frameSelector) {
        const productGrids = document.querySelectorAll(`${frameSelector} .${componentName}__product-grid`);
        Array.from(productGrids).forEach((productGrid) => {
            productGrid.innerHTML = '';
            const skeletonGridHTML = this.createSkeletonGridStructure();
            productGrid.innerHTML = skeletonGridHTML;
            productGrid.classList.add('skeleton-loading');
        });
    }

    hideGridSkeleton(frameSelector) {
        const productGrids = document.querySelectorAll(`${frameSelector} .${componentName}__product-grid`);
        Array.from(productGrids).forEach((productGrid) => {
            productGrid.innerHTML = '';
            productGrid.classList.remove('skeleton-loading');
        });
    }

    createSkeletonGridStructure() {
        const skeletonCards = [];
        const numberOfSkeletonCards = 15;

        for (let i = 0; i < numberOfSkeletonCards; i++) {
            skeletonCards.push(`
                <div class="${componentName}__skeleton-card">
                    <div class="${componentName}__skeleton-top-section">
                        <div class="${componentName}__skeleton-image"></div>
                        <div class="${componentName}__skeleton-content">
                            <div class="${componentName}__skeleton-title"></div>
                            <div class="${componentName}__skeleton-subtitle"></div>
                            <div class="${componentName}__skeleton-price"></div>
                            <div class="${componentName}__skeleton-description">
                                <div class="${componentName}__skeleton-line"></div>
                                <div class="${componentName}__skeleton-line"></div>
                                <div class="${componentName}__skeleton-line ${componentName}__skeleton-line--short"></div>
                            </div>
                        </div>
                    </div>
                </div>
            `);
        }

        return skeletonCards.join('');
    }

    async initAccessories() {
        this.showGridSkeleton(`.${componentName}__content-frame-accessories`);
        const accessories = await this.getAccessories(0, resultsPerPageAccessories);
        this.hideGridSkeleton(`.${componentName}__content-frame-accessories`);
        const productGrids = document.querySelectorAll(`.${componentName}__content-frame-accessories .${componentName}__product-grid`);
        Array.from(productGrids).forEach((productGrid) => {
            const paginationForm = productGrid.nextElementSibling;
            let index = 0;
            const catalogNumber = document.querySelector(`.${componentName}__product-detail-header`).dataset.sku;
            accessories.list.forEach((product) => {
                if (product.catalogNumber === catalogNumber) {
                    return;
                }
                const productCard = this.createProductCard(product);
                productGrid.append(productCard);

                paginationForm.querySelector(`.${componentName}__product-grid-result-count-last`).innerText = Math.min(++index, resultsPerPageAccessories);
                paginationForm.querySelector(`.${componentName}__product-grid-result-count-total`).innerText = accessories.totalResults;
                const totalPages = accessories.totalResults % resultsPerPageAccessories === 0 ? accessories.totalResults / resultsPerPageAccessories : Math.floor(accessories.totalResults / resultsPerPageAccessories) + 1;
                paginationForm.querySelector(`.${componentName}__product-grid-pagination-label span`).innerText = totalPages;
                paginationForm.querySelector(`.${componentName}__product-grid-pagination-input`).max = totalPages;

                if (accessories.totalResults > resultsPerPageAccessories) {
                    paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='next']`).disabled = false;
                }
            });
        });
    }

    async initAlternativeProducts() {
        this.showGridSkeleton(`.${componentName}__content-frame-alternative-products`);

        const productGrids = document.querySelectorAll(`.${componentName}__content-frame-alternative-products .${componentName}__product-grid`);
        const categoryUrlList = productGrids[0].dataset.categoryList.split(', ').filter((url) => url !== '');

        const alternativeProductsObject = await this.getComplemetaryProducts(0, resultsPerPageAlternativeProducts);
        const alternativeProducts = alternativeProductsObject.list;
        const totalResults = alternativeProductsObject.totalResults;

        this.hideGridSkeleton(`.${componentName}__content-frame-alternative-products`);

        Array.from(productGrids).forEach((productGrid) => {
            const paginationForm = productGrid.nextElementSibling;
            let index = 0;
            const catalogNumber = document.querySelector(`.${componentName}__product-detail-header`).dataset.sku;
            alternativeProducts.forEach((product) => {
                if (product.catalogNumber === catalogNumber) {
                    return;
                }
                const productCard = this.createProductCard(product);
                productGrid.append(productCard);

                paginationForm.querySelector(`.${componentName}__product-grid-result-count-last`).innerText = Math.min(++index, resultsPerPageAlternativeProducts);
                paginationForm.querySelector(`.${componentName}__product-grid-result-count-total`).innerText = totalResults;
                const totalPages = totalResults % resultsPerPageAlternativeProducts === 0 ? totalResults / resultsPerPageAlternativeProducts : Math.floor(totalResults / resultsPerPageAlternativeProducts) + 1;
                paginationForm.querySelector(`.${componentName}__product-grid-pagination-label span`).innerText = totalPages;
                paginationForm.querySelector(`.${componentName}__product-grid-pagination-input`).max = totalPages;
            });
            if (totalResults > resultsPerPageAlternativeProducts) {
                paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='next']`).disabled = false;
            }
        });
    }

    createProductCard(productData) {
        const pageLanguage = document.querySelector('meta[property="language"]') ? document.querySelector('meta[property="language"]').content.substr(0, 2) : 'en';
        // Determine the appropriate default image based on app type
        const isSSApp = document.querySelector(`.${componentName}--ss`) !== null;
        const ssDefaultImage = '/etc.clientlibs/rockwell-aem-base/clientlibs/clientlib-base/resources/icons/ss_image_unavailable.svg';
        const cardDefaultImage = isSSApp ? ssDefaultImage : defaultImage;
        
        let productImage = productData.picture_url ? productData.picture_url : cardDefaultImage;
        if (!productImage.includes('/')) {
            productImage = productImagePrefix + productImage;
        }
        const productCard = document.createElement('div');
        productCard.classList.add(`${componentName}__product-card`);
        productCard.innerHTML = `
            <div class="${componentName}__product-card-image-container">
                <img class="${componentName}__product-card-image" src="${productImage}" alt="${this.getTranslatableProductField(productData, 'names', 'names_value', '', pageLanguage)}"/>
            </div>
            <a class="${componentName}__product-card-catalog-number" href="details.${this.encodeCatalogNumber(productData.catalogNumber)}.html">
                ${this.getTranslatableProductField(productData, 'names', 'names_value', '', pageLanguage) ? `<span>${this.getTranslatableProductField(productData, 'names', 'names_value', '', pageLanguage)}</span>` : ''}
                <span>${productData.catalogNumber}</span>
            </a>
            <div class="${componentName}__product-card-lifecycle-status">
                <div class="${componentName}__product-card-lifecycle-status-dot ${productData.productLifeCycleStatus?.toLowerCase()}"></div>
                <div class="${componentName}__product-card-lifecycle-status-text">${productData.productLifeCycleStatus ? this.toTitleCase(productData.productLifeCycleStatus.replaceAll('_', ' ')) : ''}</div>
            </div>
            <div class="${componentName}__product-card-description">${this.getTranslatableProductField(productData, 'names', 'names_value', '', pageLanguage)?.replaceAll(',', ', ')}</div>
        `;
        // <div class="${componentName}__compare-button" tabindex="1">
        //     <input type="checkbox" class="${componentName}__compare-checkbox cmp-form-options--checkbox" data-sku="${productData.catalogNumber}" />
        //     Compare
        // </div>
        // productCard.querySelector(`.${componentName}__compare-button`).addEventListener('click', async (event) => {
        //     await this.compareCheckboxClick(event);
        // });

        const cardImage = productCard.querySelector('img');
        cardImage.onerror = () => {
            cardImage.src = cardDefaultImage;
        };
        // Check if error has already fired
        if (cardImage.complete && !cardImage.naturalWidth) {
            cardImage.src = cardDefaultImage;
        }
        return productCard;
    }

    encodeCatalogNumber = (catalogNumber) => {
        return catalogNumber.replaceAll('/', '%252F').replaceAll('.', '%252E');
    }

    async getAccessories(startIndex, numResults) {

        const locale = document.documentElement.lang ? document.documentElement.lang.toLocaleLowerCase() : 'en-us';
        let countryCode = locale.split("-")[1];
        const appType = document.querySelector(`.${componentName}__product-detail-header`).dataset.app ? document.querySelector(`.${componentName}__product-detail-header`).dataset.app.toUpperCase() : 'RA';
        const productGrid = document.querySelector(`.${componentName}__content-frame-accessories .${componentName}__product-grid`);
        const accessoriesCatalogNumberList = productGrid.dataset.accessoriesCatalognumberList;
        const accessoriesTemplateNameList = productGrid.dataset.accessoriesTemplatenameList;
        const accessories = {
            list: [],
            totalResults: 0,
        };

        let responseJson = null;
        const headers = new Headers();
        headers.append('Content-Type', 'text/plain; charset=UTF-8');
        try {
            const response = await fetch(`/bin/rockwell-automation/product-details?countryCode=${countryCode}&app=${appType}&getAccessories=true&startIndex=${startIndex}&numResults=${numResults}&accessoriesCatalogNumbers=${accessoriesCatalogNumberList}&accessoriesTemplateIDs=${accessoriesTemplateNameList}`, {
                method: 'GET',
                headers: headers,
            });
            const responseBuffer = await response.arrayBuffer();
            const responseString = new TextDecoder('ISO-8859-2').decode(responseBuffer);
            responseJson = JSON.parse(responseString);
            accessories.list = responseJson.dataList;
            accessories.totalResults = responseJson.totalNumber;
        } catch (error) {
            console.warn('Error fetching product accessories:', error);
        }
        return accessories;
    }

    async getComplemetaryProducts(startIndex, numResults) {
        const locale = document.documentElement.lang ? document.documentElement.lang.toLocaleLowerCase() : 'en-ca';
        let countryCode = locale.split("-")[1];
        const productGrid = document.querySelector(`.${componentName}__content-frame-alternative-products .${componentName}__product-grid`);
        const categoryUrlList = productGrid.dataset.categoryList.split(', ').filter((url) => url !== '');
        const appType = document.querySelector(`.${componentName}__product-detail-header`).dataset.app ? document.querySelector(`.${componentName}__product-detail-header`).dataset.app.toUpperCase() : 'RA';
        let alternativeProducts = {
            list: [],
            totalResults: 0,
        };

        let responseJson = null;
        const headers = new Headers();
        headers.append('Content-Type', 'text/plain; charset=UTF-8');
        try {
            const response = await fetch(`/bin/rockwell-automation/product-details?countryCode=${countryCode}&app=${appType}&categoryIds=${categoryUrlList.join(',')}&fields=${cardRequestedFields.join(',')}&startIndex=${startIndex}&numResults=${numResults}`, {
                method: 'GET',
                headers: headers,
            });
            const responseBuffer = await response.arrayBuffer();
            const responseString = new TextDecoder('ISO-8859-2').decode(responseBuffer);
            responseJson = JSON.parse(responseString);
            alternativeProducts.list = responseJson.docs;
            alternativeProducts.totalResults = responseJson.total;
        } catch (error) {
            console.warn('Error fetching alternative products:', error);
        }
        return alternativeProducts;
    }

    async getKnowledgebaseArticles() {
        let responseJson = null;
        let knowledgebaseArticles = [];
        const catalogNumber = document.querySelector(`.${componentName}__product-detail-header`).dataset.sku;
        const headers = new Headers();
        headers.append('Content-Type', 'text/plain; charset=UTF-8');
        try {
            const response = await fetch(`/bin/rockwell-automation/product-details?catalogNumber=${catalogNumber}&getKnoweledgebaseArticles=true`, {
                method: 'GET',
                headers: headers,
            });
            const responseBuffer = await response.arrayBuffer();
            const responseString = new TextDecoder('ISO-8859-2').decode(responseBuffer);
            responseJson = JSON.parse(responseString);
            for (let i = 0; i < Math.min(responseJson.total, 10); i++) {
                knowledgebaseArticles.push({
                    title: responseJson.docs[i].title,
                    url: responseJson.docs[i].url,
                });
            }
        } catch (error) {
            console.warn('Error fetching knowledgebase articles:', error);
        }
        return knowledgebaseArticles;
    }

    async initKnowledgebaseArticles() {
        window.dispatchEvent(new CustomEvent('show-loading'));
        const knowledgebaseArticles = await this.getKnowledgebaseArticles();
        window.dispatchEvent(new CustomEvent('hide-loading'));
        const knowledgebaseArticleLists = document.querySelectorAll(`.${componentName}__knowledgebase-articles-list`);
        Array.from(knowledgebaseArticleLists).forEach((knowledgebaseArticleList) => {
            knowledgebaseArticles.forEach((article) => {
                const articleElement = document.createElement('div');
                articleElement.classList.add(`${componentName}__knowledgebase-articles-list-item`);
                const articleLink = document.createElement('a');
                articleLink.classList.add(`${componentName}__knowledgebase-articles-list-link`);
                articleLink.href = article.url;
                articleLink.innerText = article.title;
                articleElement.append(articleLink);
                knowledgebaseArticleList.append(articleElement);
            });
        });
    }

    initDrawings() {
        this.initSignInLinks();
        const iframe = document.querySelector(`.${componentName}__drawings-iframe`);
        if (iframe) {
            iframe.setAttribute('src', iframe.dataset.src);
        }
    }

    initPagination() {
        const paginationForms = document.querySelectorAll(`.${componentName}__product-grid-pagination-form`);
        Array.from(paginationForms).forEach((paginationForm) => {
            const productGrid = paginationForm.closest(`.${componentName}__content-frame`).querySelector(`.${componentName}__product-grid`);
            paginationForm.addEventListener('submit', (event) => {
                event.preventDefault();
                const currentPage = parseInt(paginationForm.querySelector(`.${componentName}__product-grid-pagination-input`).value);
                const totalPages = +paginationForm.querySelector(`.${componentName}__product-grid-pagination-label span`).innerText.trim();
                const totalResults = +paginationForm.querySelector(`.${componentName}__product-grid-result-count-total`).innerText.trim();
                if (currentPage <= 1) {
                    paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='prev']`).disabled = true;
                } else {
                    paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='prev']`).disabled = false;
                }
                if (currentPage >= totalPages) {
                    paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='next']`).disabled = true;
                } else {
                    paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='next']`).disabled = false;
                }
                let type = '';
                if (paginationForm.closest(`.${componentName}__content-frame-accessories`)) {
                    paginationForm.querySelector(`.${componentName}__product-grid-result-count-first`).innerText = (currentPage - 1) * resultsPerPageAccessories + 1;
                    paginationForm.querySelector(`.${componentName}__product-grid-result-count-last`).innerText = Math.min(currentPage * resultsPerPageAccessories, totalResults);
                    type = 'accessories';
                } else if (paginationForm.closest(`.${componentName}__content-frame-alternative-products`)) {
                    paginationForm.querySelector(`.${componentName}__product-grid-result-count-first`).innerText = (currentPage - 1) * resultsPerPageAlternativeProducts + 1;
                    paginationForm.querySelector(`.${componentName}__product-grid-result-count-last`).innerText = Math.min(currentPage * resultsPerPageAlternativeProducts, totalResults);
                    type = 'alternative-products';
                }
                this.updateProductGridPage(productGrid, currentPage, type);
            });
            const paginationButtons = paginationForm.querySelectorAll(`.${componentName}__product-grid-pagination-button`);
            Array.from(paginationButtons).forEach((button) => {
                button.addEventListener('click', (event) => {
                    const currentPage = parseInt(paginationForm.querySelector(`.${componentName}__product-grid-pagination-input`).value);
                    const totalPages = +paginationForm.querySelector(`.${componentName}__product-grid-pagination-label span`).innerText.trim();
                    if (button.name === 'prev' && currentPage > 1) {
                        paginationForm.querySelector(`.${componentName}__product-grid-pagination-input`).value--;
                    } else if (button.name === 'next' && currentPage < totalPages) {
                        paginationForm.querySelector(`.${componentName}__product-grid-pagination-input`).value++;
                    }
                });
            });
        });
        const numResultsInputs = document.querySelectorAll(`.${componentName}__product-grid-items-per-page select`);
        Array.from(numResultsInputs).forEach((numResultsInput) => {
            const productGrid = numResultsInput.closest(`.${componentName}__content-frame`).querySelector(`.${componentName}__product-grid`);
            const paginationForm = numResultsInput.closest(`.${componentName}__content-frame`).querySelector(`.${componentName}__product-grid-pagination-form`);
            numResultsInput.addEventListener('change', (event) => {
                const totalResults = +paginationForm.querySelector(`.${componentName}__product-grid-result-count-total`).innerText.trim();
                paginationForm.querySelector(`.${componentName}__product-grid-result-count-first`).innerText = 1;
                paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='prev']`).disabled = true;
                let type = '';
                if (numResultsInput.closest(`.${componentName}__content-frame-accessories`)) {
                    resultsPerPageAccessories = parseInt(event.target.value);
                    const totalPages = totalResults % resultsPerPageAccessories === 0 ? totalResults / resultsPerPageAccessories : Math.floor(totalResults / resultsPerPageAccessories) + 1;
                    paginationForm.querySelector(`.${componentName}__product-grid-result-count-last`).innerText = Math.min(resultsPerPageAccessories, totalResults);
                    paginationForm.querySelector(`.${componentName}__product-grid-pagination-label span`).innerText = totalPages;
                    paginationForm.querySelector(`.${componentName}__product-grid-pagination-input`).max = totalPages;
                    if (totalPages === 1) {
                        paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='next']`).disabled = true;
                    } else {
                        paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='next']`).disabled = false;
                    }
                    type = 'accessories';
                } else if (numResultsInput.closest(`.${componentName}__content-frame-alternative-products`)) {
                    resultsPerPageAlternativeProducts = parseInt(event.target.value);
                    const totalPages = totalResults % resultsPerPageAlternativeProducts === 0 ? totalResults / resultsPerPageAlternativeProducts : Math.floor(totalResults / resultsPerPageAlternativeProducts) + 1;
                    paginationForm.querySelector(`.${componentName}__product-grid-result-count-last`).innerText = Math.min(resultsPerPageAlternativeProducts, totalResults);
                    paginationForm.querySelector(`.${componentName}__product-grid-pagination-label span`).innerText = totalPages;
                    paginationForm.querySelector(`.${componentName}__product-grid-pagination-input`).max = totalPages;
                    if (totalPages === 1) {
                        paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='next']`).disabled = true;
                    } else {
                        paginationForm.querySelector(`.${componentName}__product-grid-pagination-button[name='next']`).disabled = false;
                    }
                    type = 'alternative-products';
                }
                paginationForm.querySelector(`.${componentName}__product-grid-pagination-input`).value = 1;
                this.updateProductGridPage(productGrid, 1, type);
            });
        });
    }

    async updateProductGridPage(productGrid, currentPage, type) {
        productGrid.innerHTML = '';
        const catalogNumber = document.querySelector(`.${componentName}__product-detail-header`).dataset.sku;
        if (type === 'accessories') {
            this.showGridSkeleton(`.${componentName}__content-frame-accessories`);
            scrollToAnchor(productGrid);
            const accessories = await this.getAccessories((currentPage - 1), resultsPerPageAccessories);
            this.hideGridSkeleton(`.${componentName}__content-frame-accessories`);
            accessories.list.forEach((product) => {
                if (product.catalogNumber === catalogNumber) {
                    return;
                }
                const productCard = this.createProductCard(product);
                productGrid.append(productCard);
            });
        } else if (type === 'alternative-products') {
            this.showGridSkeleton(`.${componentName}__content-frame-alternative-products`);
            scrollToAnchor(productGrid);
            const alternativeProductsObject = await this.getComplemetaryProducts(((currentPage - 1) * resultsPerPageAlternativeProducts), resultsPerPageAlternativeProducts);
            const alternativeProducts = alternativeProductsObject.list;
            this.hideGridSkeleton(`.${componentName}__content-frame-alternative-products`);
            alternativeProducts.forEach((product) => {
                if (product.catalogNumber === catalogNumber) {
                    return;
                }
                const productCard = this.createProductCard(product);
                productGrid.append(productCard);
            });
        }
    }

    initSerialNumberTooltip() {
        const tooltipContainers = document.querySelectorAll(`.${componentName}__serial-number-tooltip-container`);

        tooltipContainers.forEach(container => {
            const tooltip = container.querySelector(`.${componentName}__serial-number-tooltip`);

            if (!tooltip) return;

            // Show tooltip on mouse enter
            container.addEventListener('mouseenter', () => {
                tooltip.style.opacity = '1';
                tooltip.style.visibility = 'visible';
            });

            // Hide tooltip on mouse leave
            container.addEventListener('mouseleave', () => {
                tooltip.style.opacity = '0';
                tooltip.style.visibility = 'hidden';
            });

            // Show tooltip on focus (for accessibility)
            container.addEventListener('focus', () => {
                tooltip.style.opacity = '1';
                tooltip.style.visibility = 'visible';
            });

            // Hide tooltip on blur (for accessibility)
            container.addEventListener('blur', () => {
                tooltip.style.opacity = '0';
                tooltip.style.visibility = 'hidden';
            });
        });
    }

    getTranslatableProductField(productJson, field, flattenedField, defaultValue, language) {
        if (productJson[field] && productJson[field] instanceof Array) {
            try {
                for (let i = 0; i < productJson[field].length; i++) {
                    if (productJson[field][i].isocode.toLowerCase() === language.toLowerCase()) {
                        return productJson[field][i].value;
                    }
                }
            } catch (error) {
                console.warn(`Error getting translatable product field ${field} for language ${language}:`, error);
            }
            if (language.toLowerCase() !== 'en') {
                return this.getTranslatableProductField(productJson, field, flattenedField, defaultValue, 'en');
            }
        }
        return productJson[flattenedField] ? productJson[flattenedField].value : defaultValue;
    }
}

function init() {
    const product = document.querySelector(".product-new");
    if (product) {
        new Product();
        let sku = document.querySelector(`.product-new .${componentName}__product-detail-header`)?.dataset.sku;
        let productName = document.querySelector(`.product-new .${componentName}__product-detail-header`)?.dataset.productName;
        if (productName != undefined) {
            // Appending to Breadcrumb
            const lastBreadcrumbItem = document.querySelector('.breadcrumb__item:last-child');
            if (lastBreadcrumbItem) {
                const clonedItem = lastBreadcrumbItem.cloneNode(true);
                lastBreadcrumbItem.insertAdjacentElement('afterend', clonedItem);

                const lastBreadcrumbText = document.querySelector('.breadcrumb__link_text:last-child');
                if (lastBreadcrumbText) {
                    lastBreadcrumbText.textContent = sku;
                }

                const lastBreadcrumbLink = document.querySelector('.breadcrumb__link:last-child');
                if (lastBreadcrumbLink) {
                    // Remove the link wrapper, keeping just the text
                    const textContent = lastBreadcrumbLink.textContent;
                    lastBreadcrumbLink.outerHTML = textContent;
                }
            }

            const emailPageElement = document.querySelector(`${componentName}__email-page`);
            if (emailPageElement) {
                emailPageElement.addEventListener('click', () => {
                    let uri = document.querySelector('link[rel="canonical"]')?.getAttribute('href');
                    let catalogNumber = 'Catalog #: ' + sku;
                    let brand = 'Rockwell Automation';
                    let body = productName + ' from ' + brand + '\n' + catalogNumber + '\n' + uri + '\n';
                    window.location.href = 'mailto:?subject=' + encodeURIComponent(brand + ' ' + productName) + '&body=' + encodeURIComponent(body);
                });
            }

            let locale = document.querySelector(".search__configuration")?.getAttribute("data-search-locale") || 'en-US';
            let searchEndpoint = document.querySelector(".search__configuration")?.getAttribute('data-search-base-url') || 'https://www.rockwellautomation.com/search';
            let endpoint = `${searchEndpoint}/ra-${locale};keyword=${sku};activeTab=Literature;`;
            const literatureResult = document.querySelector('#literature-result');
            if (literatureResult) {
                literatureResult.setAttribute("href", endpoint);
            }
        }
    }
}
window.piraInitPdp = init;

let signInEventListenerAdded = false;
let alreadySignedIn = false;
let technicalSpecsLoaded = false;

function loadFullTechnicalSpecs() {
    const hiddenFieldsIndicator = document.querySelector(`.${componentName}__hidden-fields-indicator`);
    if (!hiddenFieldsIndicator || technicalSpecsLoaded) {
        return;
    }

    technicalSpecsLoaded = true;
    const sku = hiddenFieldsIndicator.dataset.sku;

    // Get the current page path without query params and hash
    const currentPath = window.location.pathname;
    // Extract SKU from path like: /content/.../details.20BD5P0A0AYNAED0.html
    // Convert to: /content/.../details/jcr:content/root/main-par/product.fullspecs.20BD5P0A0AYNAED0.html
    const pathWithoutSku = currentPath.replace(/\.[^\/]+\.html$/, '');
    const contentPath = pathWithoutSku + '/jcr:content/root/main-par/product.fullspecs.' + sku + '.html';

    console.log(`### Loading full technical specifications from: ${contentPath}`);

    // Make AJAX request to load full specifications
    fetch(contentPath)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
        })
        .then(html => {
            console.log('### Successfully loaded full technical specifications');
            // Create a temporary container to parse the HTML
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;

            // The fullspecs selector should only return the spec table, not the dropdowns
            // Find the spec table from the AJAX response
            const newSpecTable = tempDiv.querySelector(`#${componentName}__spec-table`);

            // Replace only the spec table content
            if (newSpecTable) {
                // Replace in desktop view
                const existingDesktopTable = document.querySelector(`.${componentName}__content-desktop #${componentName}__spec-table`);
                if (existingDesktopTable) {
                    console.log('### Replacing desktop spec table with full specifications');
                    existingDesktopTable.innerHTML = newSpecTable.innerHTML;
                }

                // Replace in mobile view - mobile also uses the same ID
                const existingMobileTable = document.querySelector(`.${componentName}__content-mobile #${componentName}__spec-table`);
                if (existingMobileTable) {
                    console.log('### Replacing mobile spec table with full specifications');
                    existingMobileTable.innerHTML = newSpecTable.innerHTML;
                }
            }

            // Hide the login prompts (using drawings-iframe-placeholder class for styling)
            const loginPrompts = document.querySelectorAll(`.${componentName}__spec-login-prompt`);
            Array.from(loginPrompts).forEach((prompt) => {
                prompt.style.display = 'none';
                prompt.classList.remove('active'); // Make sure active class is removed
            });

            // No need to re-initialize selects since we're not touching the dropdowns
        })
        .catch(error => {
            console.error('### Failed to load full technical specifications:', error);
        });
}

function checkSignIn() {
    let isSignedIn = false;
    try {
        isSignedIn = !!(window['userData'] || JSON.parse(localStorage.getItem('loggedInData')));
    } catch (e) { }

    console.log(`### User signed in status: ${isSignedIn ? 'SIGNED IN' : 'NOT SIGNED IN'}`);

    const iframeElements = document.querySelectorAll(`.${componentName}__drawings-iframe`);
    const iframePlaceholders = document.querySelectorAll(`.${componentName}__drawings-iframe-placeholder`);
    const specLoginPrompts = document.querySelectorAll(`.${componentName}__spec-login-prompt`);
    const hiddenFieldsIndicator = document.querySelector(`.${componentName}__hidden-fields-indicator`);

    if (isSignedIn) {
        if (alreadySignedIn) {
            return;
        }
        alreadySignedIn = true;
        try {
            window.removeEventListener('message', checkSignIn);
        } catch (e) { }

        // Handle drawings iframe
        if (iframeElements.length > 0) {
            Array.from(iframeElements).forEach((iframeElement) => {
                iframeElement.classList.add('active');
            });
        }

        Array.from(iframePlaceholders).forEach((iframePlaceholder) => {
            iframePlaceholder.classList.remove('active');
        });

        // Handle technical specifications
        if (hiddenFieldsIndicator && hiddenFieldsIndicator.dataset.hasHiddenFields === 'true') {
            console.log('### Hidden fields detected, loading full technical specifications via AJAX');
            // Load full technical specifications via AJAX
            loadFullTechnicalSpecs();
        }

        const jsonDownloadButton = document.querySelector(`.${componentName}__json-download-button`);
        const dppCookie = document.cookie.split('; ').find(row => row.startsWith('dppJson='));
        const dppQueryParama = new URLSearchParams(window.location.search).get('dpp');
        if (jsonDownloadButton
            && (jsonDownloadButton.dataset.dppNotRequired === 'true' || dppQueryParama === 'true' || dppCookie === 'true')
        ) {
            jsonDownloadButton.classList.remove('hidden');
        }
    } else {
        if (!signInEventListenerAdded) {
            signInEventListenerAdded = true;
            window.addEventListener('message', checkSignIn);
        }

        // Handle drawings placeholders
        Array.from(iframePlaceholders).forEach((iframePlaceholder) => {
            iframePlaceholder.classList.add('active');
        });

        if (iframeElements.length > 0) {
            Array.from(iframeElements).forEach((iframeElement) => {
                iframeElement.classList.remove('active');
            });
        }

        // Show technical specifications login prompts (using same styling as drawings)
        if (hiddenFieldsIndicator && hiddenFieldsIndicator.dataset.hasHiddenFields === 'true') {
            console.log('### Hidden fields detected, showing login prompt for technical specifications');
            Array.from(specLoginPrompts).forEach((prompt) => {
                prompt.style.display = 'flex'; // Use flex like drawings placeholder
                prompt.classList.add('active'); // Add active class like drawings
            });
        }
    }
}

function main() {
    init();
    checkSignIn();
    const hash = window.location.hash;
    if (hash && hash.startsWith("#sustainability_")) {
        const targetElement = document.getElementById('sustainability-subcategory-items');
        if (targetElement) {
            targetElement.classList.remove("ra-product-new__subcategory-items-collapse");
        }
    }

}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', main);
} else {
    main();
}
